// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".32a5fbacb8baba677a46abc7d3308eff8d06d7a1.chunk.bundle.js";
};